import { render, staticRenderFns } from "./RoleSettingView.vue?vue&type=template&id=2d61929d&scoped=true&"
import script from "./RoleSettingView.vue?vue&type=script&lang=js&"
export * from "./RoleSettingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d61929d",
  null
  
)

export default component.exports